import { useEffect, useState } from "react";
import logo from "../../../images/logo.svg";
import home from "../../../images/home.svg";
import craneLogo from "../../../images/craneLogo.png";
import services from "../../../images/services.svg";
import config from "../../../images/config.svg";
import maleta from "../../../images/maleta.svg";
import plus from "../../../images/plus.svg";
import tow from "../../../images/tow-icon.svg";
import threedots from "../../../images/threedots.svg";
import administration from "../../../images/administracion.svg";
import navOptionArrow from "../../../images/navOptionArrow.svg";
import { NavLink, useHistory } from "react-router-dom";
import { readRole, operationsRoles } from "../../../assets/helpers/roles";
import auth from "../../../services/authService";
import { LogOutModal } from "../../../components/common/Modals/Modals";
import authService from "../../../services/authService";
import { connectSocket, disconnectSocket } from '../../../services/socketService';
import { useSocketConnectionStore } from '../../../stores/socketConnectionStore';
import { invalidateTimeParamsCache } from "../../../services/timeParamsService";
import "./Header.scss";

const {
  operationsAdmin,
  operationsDev,
  operationsSupervisor,
  operationsOperator,
  OPERATIONS_FLOTA_GRUA,
  OPERATIONS_FLOTA_AV,
  OPERATIONS_FLOTA_GRUA_EXT,
} = operationsRoles;

const links = [
  {
    name: "Servicios",
    link: "services",
    src: home,
    roles: [
      operationsAdmin,
      operationsDev,
      operationsSupervisor,
      operationsOperator,
      // OPERATIONS_FLOTA_GRUA,
      // OPERATIONS_FLOTA_AV,
      // OPERATIONS_FLOTA_GRUA_EXT,
    ],
  },
  {
    name: "Estadisticas",
    link: "providers-stats",
    src: "",
    roles: [
      OPERATIONS_FLOTA_AV,
      OPERATIONS_FLOTA_GRUA,
      OPERATIONS_FLOTA_GRUA_EXT,
    ],
  },
  {
    name: "Estadísticas",
    link: "stats",
    src: services,
    levels: [
      {
        name: "Operación",
        url: "operations",
        roles: [operationsDev, operationsAdmin, operationsSupervisor],
      },
      {
        name: "Exportables",
        url: "exportable",
        roles: [operationsDev, operationsAdmin, operationsSupervisor],
      },
      {
        name: "Revisiones",
        url: "reviews",
        roles: [operationsDev, operationsAdmin],
      },
      {
        name: "Contador Operaciones",
        url: "operators-counter",
        operationsSupervisor,
        roles: [
          operationsDev,
          operationsAdmin,
          operationsOperator,
          operationsSupervisor,
        ],
      },
      {
        name: "Servicio Agendado",
        url: "scheduled-service",
        roles: [
          operationsDev,
          operationsAdmin,
          operationsOperator,
          operationsSupervisor,
        ],
      },
      {
        name: "Sección de Quejas",
        url: "complaints",
        roles: [
          operationsDev,
          operationsAdmin,
          operationsSupervisor,
          operationsOperator,
        ],
      },
      {
        name: "Seccion TV",
        url: "tv-section",
        roles: [
          operationsDev,
          operationsAdmin,
          operationsSupervisor,
        ],
      },
      {
        name: "Clientes Potenciales",
        url: "particular-clients",
        roles: [
          operationsDev,
          operationsAdmin,
          operationsSupervisor,
          operationsOperator,
        ],
      },
    ],
    roles: [
      operationsAdmin,
      operationsDev,
      operationsSupervisor,
      operationsOperator,
    ],
  },
  {
    name: "Proveedores",
    link: "providers",
    src: maleta,
    levels: [
      {
        name: "Proveedores Externos",
        url: "external",
        roles: [
          operationsDev,
          operationsAdmin,
          operationsOperator,
          operationsSupervisor,
        ],
      },
      {
        name: "Alianzas",
        url: "alliances",
        roles: [operationsDev, operationsAdmin, operationsSupervisor],
      },
      {
        name: "Pago de Proveedores",
        url: "providers-payments",
        roles: [operationsDev, operationsAdmin],
      },
      {
        name: "Aprobación Averías Resueltas",
        url: "approve-faults-resolved",
        roles: [operationsDev, operationsAdmin, operationsSupervisor],
      },
      {
        name: "Venta de Baterías",
        url: "battery-sales",
        roles: [operationsDev, operationsAdmin, operationsSupervisor],
      },
    ],
    roles: [
      operationsDev,
      operationsAdmin,
      operationsOperator,
      operationsSupervisor,
    ],
  },
  {
    name: "Incidencia",
    link: "incidence",
    src: plus,
    levels: [
      { name: "Afiliado", url: "create-affiliated" },
      { name: "Particular", url: "create/particular" },
      { name: "Aliado", url: "create/alliance" },
    ],
    roles: [
      operationsDev,
      operationsAdmin,
      operationsSupervisor,
      operationsOperator,
    ],
  },
  {
    name: "Flota",
    link: "fleet",
    src: tow,
    levels: [
      {
        name: "Chóferes Internos",
        url: "internal",
        roles: [operationsDev, operationsAdmin, operationsSupervisor],
      },
      {
        name: "Flota",
        url: "",
        roles: [operationsDev, operationsAdmin, operationsSupervisor],
      },
      {
        name: "Mantenimiento de flota",
        url: "maintenance",
        roles: [operationsDev, operationsAdmin],
      },
      // {
      //   name: "Ubicación de Flota",
      //   url: "fleet-location",
      //   roles: [operationsDev, operationsAdmin, operationsSupervisor],
      // },
      {
        name: "Ubicación de Choferes",
        url: "drivers-location",
        roles: [operationsDev, operationsAdmin, operationsSupervisor, operationsOperator],
      },
      {
        name: "Ubicación de Flota",
        url: "fleet-location",
        roles: [operationsDev, operationsAdmin, operationsSupervisor],
      },
      {
        name: "Links de Seguimiento",
        url: "folowing-links",
        roles: [
          operationsDev,
          operationsAdmin,
          operationsOperator,
          operationsSupervisor,
        ],
      },
    ],
    roles: [
      operationsDev,
      operationsAdmin,
      operationsSupervisor,
      operationsOperator,
    ],
  },
  {
    name: "Administración",
    link: "admin",
    src: administration,
    levels: [
      { name: "Validacion de Pagos", url: "payments-validation", roles: [operationsDev, operationsAdmin] },

    ],
    roles: [operationsDev, operationsAdmin],
  },
  {
    name: "Configuración",
    link: "config",
    src: config,
    levels: [
      { name: "Usuarios", url: "users" },
      { name: "Códigos Ridery", url: "ridery-codes", roles: [operationsDev, operationsAdmin] },
      { name: "Parametros", url: "parameters", roles: [operationsDev, operationsAdmin] },
      // { name: 'Parametros', url: 'parameters' },
    ],
    roles: [operationsDev, operationsAdmin, operationsSupervisor],
  },
  {
    name: "Servicio de Taller",
    src: plus,
    link: "garage",
    levels: [{ name: "Facturación Taller", url: "billing" }],
    roles: [operationsAdmin, operationsDev],
  },
];

export const SublevelComponent = (props) => {
  const { link, level, closeFirstLevel } = props;

  // Si el subnivel tiene roles asignados y no incluye alguno en si lista no muestra el subnivel
  //si el subnivel no tiene roles asignados muestralo siempre
  if (level.roles?.length > 0 && !level.roles.includes(auth.getUserType())) {
    return null;
  }
  return (
    <NavLink to={`/` + link.link + `/${level?.url}`}>
      <div
        onClick={() => closeFirstLevel()}
        className="header-sublevel-option"
        key={level.name}
      >
        {level.name}
      </div>
    </NavLink>
  );
};

export const LinkComponent = (props) => {
  const { index, link, openFirstLevel, closeFirstLevel } = props;

  let selected = "";

  if (window.location.href.includes(link.link)) {
    selected = true;
  }

  if (!link?.roles.includes(auth.getUserType())) {
    return null;
  }

  if (link?.levels?.length > 0) {
    return (
      <>
        {link?.isOpen && (
          <div
            className="header-sublevel-container"
            onClick={() => closeFirstLevel()}
          ></div>
        )}
        <div
          className={`link-component link-component-${selected}`}
          onClick={
            link.isOpen ? () => closeFirstLevel() : () => openFirstLevel(index)
          }
        >
          <img className="link-component-logo" src={link.src} alt="icon" />
          <span>{link.name}</span>
          <img
            className="link-component-arrow"
            src={navOptionArrow}
            alt="navOptionArrow"
          />

          {link?.isOpen && (
            <>
              <div className="header-sublevel-section">
                {link.levels.map((l) => (
                  <SublevelComponent
                    key={l.url}
                    link={link}
                    level={l}
                    closeFirstLevel={closeFirstLevel}
                  />
                ))}
              </div>
            </>
          )}
        </div>
      </>
    );
  } else {
    return (
      <div
        className={`link-component link-component-${selected}`}
        onClick={() => closeFirstLevel()}
      >
        <NavLink to={`/` + link.link}>
          {link.src && (
            <img className="link-component-logo" src={link.src} alt="icon" />
          )}
          <span>{link.name}</span>
        </NavLink>
      </div>
    );
  }
};

export const Header = () => {
  const isSocketConnected = useSocketConnectionStore((state) => state.isConnected);
  const history = useHistory();
  const [linkOptions, setLinkOptions] = useState(links);
  const [logOutModal, setLogOutModal] = useState({
    isOpen: false,
  });

  let user = sessionStorage.getItem("user");
  user = JSON.parse(user);

  const openFirstLevel = (index) => {
    let links = linkOptions;
    for (let i = 0; i < links.length; i++) {
      links[i].isOpen = false;
    }
    links[index].isOpen = true;

    setLinkOptions((prevState) => {
      return [...links];
    });
  };

  const closeFirstLevel = (index) => {
    let links = linkOptions;
    for (let i = 0; i < links.length; i++) {
      links[i].isOpen = false;
    }

    setLinkOptions((prevState) => {
      return [...links];
    });
  };

  const handleLogoutModal = () => {
    setLogOutModal((prevState) => {
      return {
        ...prevState,
        isOpen: !logOutModal?.isOpen,
      };
    });
  };

  const signOut = () => {
    disconnectSocket();
    handleLogoutModal();
    invalidateTimeParamsCache();
    sessionStorage.clear();
    history.push("/login");
  };

  const redirectHome = () => {
    if (history.location.pathname === "/services") {
      window.location.reload();
    } else {
      history.push("/services");
    }
  };


  useEffect(() => {
    const token = auth.getToken();
    const userData = auth.getUser();
    if (token && userData?._id) {
      connectSocket(userData._id, token);
    }
  }, []);

  return (
    <>
      <LogOutModal
        modal={logOutModal}
        handleModal={handleLogoutModal}
        action={signOut}
      />
      <div className="header-component">
        <div className="header-links-container">
          <div className="navbar-options-container">
            {![
              OPERATIONS_FLOTA_GRUA,
              OPERATIONS_FLOTA_AV,
              OPERATIONS_FLOTA_GRUA_EXT,
            ]?.includes(authService?.getUserType()) && (
                <>
                  <img
                    onClick={() => redirectHome()}
                    src={logo}
                    alt="logo"
                    className="header-logo"
                  />
                  <img
                    onClick={() => redirectHome()}
                    src={craneLogo}
                    alt="logo"
                    className="header-logo-small"
                  />
                </>
              )}
            {linkOptions.map((l, i) => (
              <LinkComponent
                key={l.name}
                index={i}
                link={l}
                openFirstLevel={openFirstLevel}
                closeFirstLevel={closeFirstLevel}
              />
            ))}
          </div>
          <div className="header-name-settins-container">
            <span
              className="socket-status-label"
              style={{
                marginRight: '12px',
                width: '8px',
                height: '8px',
                borderRadius: '50%',
                backgroundColor: isSocketConnected ? '#27ae60' : '#e74c3c',
              }}
              title={isSocketConnected ? 'Conectado' : 'Desconectado'}
            />
            <h6>
              {user?.firstName} {user?.lastName}{" "}
              <span style={{ marginLeft: "12px", textTransform: "uppercase" }}>
                {readRole(user?.roles[0]?.code)}
              </span>
            </h6>
            <img
              onClick={() => handleLogoutModal()}
              src={threedots}
              alt={"threedots"}
            ></img>
          </div>
        </div>
      </div>
    </>
  );
};
